export default __webpack_public_path__ + "static/media/093-right-arrow-7.a588bb87.png";